@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.profile.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/mobile_wallet.feature.profile.generated.resources/"

internal val Res.string.feature_profile_approve_description: StringResource by lazy {
      StringResource("string:feature_profile_approve_description", "feature_profile_approve_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 135),
      ))
    }

internal val Res.string.feature_profile_change_profile_picture: StringResource by lazy {
      StringResource("string:feature_profile_change_profile_picture", "feature_profile_change_profile_picture", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146, 90),
      ))
    }

internal val Res.string.feature_profile_click_profile_picture: StringResource by lazy {
      StringResource("string:feature_profile_click_profile_picture", "feature_profile_click_profile_picture", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237, 73),
      ))
    }

internal val Res.string.feature_profile_confirm_text: StringResource by lazy {
      StringResource("string:feature_profile_confirm_text", "feature_profile_confirm_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 311, 48),
      ))
    }

internal val Res.string.feature_profile_discard_changes: StringResource by lazy {
      StringResource("string:feature_profile_discard_changes", "feature_profile_discard_changes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 360, 83),
      ))
    }

internal val Res.string.feature_profile_dismiss: StringResource by lazy {
      StringResource("string:feature_profile_dismiss", "feature_profile_dismiss", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 489, 43),
      ))
    }

internal val Res.string.feature_profile_dismiss_text: StringResource by lazy {
      StringResource("string:feature_profile_dismiss_text", "feature_profile_dismiss_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 444, 44),
      ))
    }

internal val Res.string.feature_profile_edit_profile: StringResource by lazy {
      StringResource("string:feature_profile_edit_profile", "feature_profile_edit_profile", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 533, 52),
      ))
    }

internal val Res.string.feature_profile_email: StringResource by lazy {
      StringResource("string:feature_profile_email", "feature_profile_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 586, 37),
      ))
    }

internal val Res.string.feature_profile_error_empty_email: StringResource by lazy {
      StringResource("string:feature_profile_error_empty_email", "feature_profile_error_empty_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 624, 73),
      ))
    }

internal val Res.string.feature_profile_error_empty_firstname: StringResource by lazy {
      StringResource("string:feature_profile_error_empty_firstname", "feature_profile_error_empty_firstname", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 698, 85),
      ))
    }

internal val Res.string.feature_profile_error_empty_lastname: StringResource by lazy {
      StringResource("string:feature_profile_error_empty_lastname", "feature_profile_error_empty_lastname", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 784, 84),
      ))
    }

internal val Res.string.feature_profile_error_empty_phone: StringResource by lazy {
      StringResource("string:feature_profile_error_empty_phone", "feature_profile_error_empty_phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 869, 85),
      ))
    }

internal val Res.string.feature_profile_error_invalid_email: StringResource by lazy {
      StringResource("string:feature_profile_error_invalid_email", "feature_profile_error_invalid_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 955, 79),
      ))
    }

internal val Res.string.feature_profile_error_invalid_phone_length: StringResource by lazy {
      StringResource("string:feature_profile_error_invalid_phone_length", "feature_profile_error_invalid_phone_length", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1035, 102),
      ))
    }

internal val Res.string.feature_profile_error_loading_client_image: StringResource by lazy {
      StringResource("string:feature_profile_error_loading_client_image", "feature_profile_error_loading_client_image", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1138, 90),
      ))
    }

internal val Res.string.feature_profile_error_updating_client_image: StringResource by lazy {
      StringResource("string:feature_profile_error_updating_client_image", "feature_profile_error_updating_client_image", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1229, 91),
      ))
    }

internal val Res.string.feature_profile_failed_to_save_changes: StringResource by lazy {
      StringResource("string:feature_profile_failed_to_save_changes", "feature_profile_failed_to_save_changes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1321, 78),
      ))
    }

internal val Res.string.feature_profile_firstname: StringResource by lazy {
      StringResource("string:feature_profile_firstname", "feature_profile_firstname", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1400, 49),
      ))
    }

internal val Res.string.feature_profile_lastname: StringResource by lazy {
      StringResource("string:feature_profile_lastname", "feature_profile_lastname", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1450, 44),
      ))
    }

internal val Res.string.feature_profile_link_bank_account: StringResource by lazy {
      StringResource("string:feature_profile_link_bank_account", "feature_profile_link_bank_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1495, 65),
      ))
    }

internal val Res.string.feature_profile_loading: StringResource by lazy {
      StringResource("string:feature_profile_loading", "feature_profile_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1561, 43),
      ))
    }

internal val Res.string.feature_profile_mobile: StringResource by lazy {
      StringResource("string:feature_profile_mobile", "feature_profile_mobile", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1605, 50),
      ))
    }

internal val Res.string.feature_profile_permission_required: StringResource by lazy {
      StringResource("string:feature_profile_permission_required", "feature_profile_permission_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1656, 71),
      ))
    }

internal val Res.string.feature_profile_personal_qr_code: StringResource by lazy {
      StringResource("string:feature_profile_personal_qr_code", "feature_profile_personal_qr_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1728, 64),
      ))
    }

internal val Res.string.feature_profile_phone_number: StringResource by lazy {
      StringResource("string:feature_profile_phone_number", "feature_profile_phone_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1793, 52),
      ))
    }

internal val Res.string.feature_profile_proceed: StringResource by lazy {
      StringResource("string:feature_profile_proceed", "feature_profile_proceed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1846, 43),
      ))
    }

internal val Res.string.feature_profile_profile_image_description: StringResource by lazy {
      StringResource("string:feature_profile_profile_image_description", "feature_profile_profile_image_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1890, 69),
      ))
    }

internal val Res.string.feature_profile_profile_image_updated_successfully: StringResource by lazy {
      StringResource("string:feature_profile_profile_image_updated_successfully", "feature_profile_profile_image_updated_successfully", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1960, 106),
      ))
    }

internal val Res.string.feature_profile_profile_updated_successfully: StringResource by lazy {
      StringResource("string:feature_profile_profile_updated_successfully", "feature_profile_profile_updated_successfully", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2067, 92),
      ))
    }

internal val Res.string.feature_profile_remove_profile_picture: StringResource by lazy {
      StringResource("string:feature_profile_remove_profile_picture", "feature_profile_remove_profile_picture", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2160, 78),
      ))
    }

internal val Res.string.feature_profile_save: StringResource by lazy {
      StringResource("string:feature_profile_save", "feature_profile_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2239, 36),
      ))
    }

internal val Res.string.feature_profile_settings: StringResource by lazy {
      StringResource("string:feature_profile_settings", "feature_profile_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2276, 44),
      ))
    }

internal val Res.string.feature_profile_updated_sucessfully: StringResource by lazy {
      StringResource("string:feature_profile_updated_sucessfully", "feature_profile_updated_sucessfully", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2321, 71),
      ))
    }

internal val Res.string.feature_profile_username: StringResource by lazy {
      StringResource("string:feature_profile_username", "feature_profile_username", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2393, 44),
      ))
    }

internal val Res.string.feature_profile_vpa: StringResource by lazy {
      StringResource("string:feature_profile_vpa", "feature_profile_vpa", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2438, 31),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_profile_approve_description", Res.string.feature_profile_approve_description)
  map.put("feature_profile_change_profile_picture", Res.string.feature_profile_change_profile_picture)
  map.put("feature_profile_click_profile_picture", Res.string.feature_profile_click_profile_picture)
  map.put("feature_profile_confirm_text", Res.string.feature_profile_confirm_text)
  map.put("feature_profile_discard_changes", Res.string.feature_profile_discard_changes)
  map.put("feature_profile_dismiss", Res.string.feature_profile_dismiss)
  map.put("feature_profile_dismiss_text", Res.string.feature_profile_dismiss_text)
  map.put("feature_profile_edit_profile", Res.string.feature_profile_edit_profile)
  map.put("feature_profile_email", Res.string.feature_profile_email)
  map.put("feature_profile_error_empty_email", Res.string.feature_profile_error_empty_email)
  map.put("feature_profile_error_empty_firstname", Res.string.feature_profile_error_empty_firstname)
  map.put("feature_profile_error_empty_lastname", Res.string.feature_profile_error_empty_lastname)
  map.put("feature_profile_error_empty_phone", Res.string.feature_profile_error_empty_phone)
  map.put("feature_profile_error_invalid_email", Res.string.feature_profile_error_invalid_email)
  map.put("feature_profile_error_invalid_phone_length", Res.string.feature_profile_error_invalid_phone_length)
  map.put("feature_profile_error_loading_client_image", Res.string.feature_profile_error_loading_client_image)
  map.put("feature_profile_error_updating_client_image", Res.string.feature_profile_error_updating_client_image)
  map.put("feature_profile_failed_to_save_changes", Res.string.feature_profile_failed_to_save_changes)
  map.put("feature_profile_firstname", Res.string.feature_profile_firstname)
  map.put("feature_profile_lastname", Res.string.feature_profile_lastname)
  map.put("feature_profile_link_bank_account", Res.string.feature_profile_link_bank_account)
  map.put("feature_profile_loading", Res.string.feature_profile_loading)
  map.put("feature_profile_mobile", Res.string.feature_profile_mobile)
  map.put("feature_profile_permission_required", Res.string.feature_profile_permission_required)
  map.put("feature_profile_personal_qr_code", Res.string.feature_profile_personal_qr_code)
  map.put("feature_profile_phone_number", Res.string.feature_profile_phone_number)
  map.put("feature_profile_proceed", Res.string.feature_profile_proceed)
  map.put("feature_profile_profile_image_description", Res.string.feature_profile_profile_image_description)
  map.put("feature_profile_profile_image_updated_successfully", Res.string.feature_profile_profile_image_updated_successfully)
  map.put("feature_profile_profile_updated_successfully", Res.string.feature_profile_profile_updated_successfully)
  map.put("feature_profile_remove_profile_picture", Res.string.feature_profile_remove_profile_picture)
  map.put("feature_profile_save", Res.string.feature_profile_save)
  map.put("feature_profile_settings", Res.string.feature_profile_settings)
  map.put("feature_profile_updated_sucessfully", Res.string.feature_profile_updated_sucessfully)
  map.put("feature_profile_username", Res.string.feature_profile_username)
  map.put("feature_profile_vpa", Res.string.feature_profile_vpa)
}
